import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom';

const BillingSuccess = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const email = searchParams.get('email');
        const redirectStatus = searchParams.get('redirect_status');

        navigate(
            `/billing?email=${encodeURIComponent(email)}&redirect_status=${redirectStatus}`
        );
    }, [navigate])

    return <p>Finalising payment...</p>;
}

export default BillingSuccess
